import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";

function QuestionnaireFormView({
  relations,
  selectedStep,
  selectedStepIndex,
  onQuestionnaireChange,
  onProceedOnErrorChange,
  onQuestionnaireExpirationChange,
  onLinkToHouserulesChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.questionnaire_id",
        )}
        required
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.questionnaire_id`,
          submitError,
        )}
      >
        <Select
          value={selectedStep?.questionnaire_id}
          options={relations?.questionnaires?.records?.map((questionnaire) => ({
            value: questionnaire.id,
            label: questionnaire.name,
          }))}
          onChange={onQuestionnaireChange}
        />
      </InputWrapper>

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.questionnaire_expiration",
        )}
        required
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.questionnaire_expiration`,
          submitError,
        )}
      >
        <StyledInput
          type="number"
          value={selectedStep?.questionnaire_expiration}
          onChange={onQuestionnaireExpirationChange}
        />
      </InputWrapper>

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.link_to_houserules",
        )}
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.link_to_houserules`,
          submitError,
        )}
        required
      >
        <Select
          value={selectedStep?.link_to_houserules}
          options={[
            { value: true, label: translate("eva.main.general.yes") },
            { value: false, label: translate("eva.main.general.no") },
          ]}
          onChange={onLinkToHouserulesChange}
        />
      </InputWrapper>

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.proceed_on_error",
        )}
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.proceed_on_error`,
          submitError,
        )}
      >
        <Select
          value={selectedStep?.proceed_on_error}
          options={[
            { value: true, label: translate("eva.main.general.yes") },
            { value: false, label: translate("eva.main.general.no") },
          ]}
          onChange={onProceedOnErrorChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default QuestionnaireFormView;
